const gallerySk = {
    "file_upload_successful": "Nahranie súboru bolo úspešné",
    "file_upload_error": "Chyba pri nahrávaní súboru",
    "attach_files": "Priložiť súbory",
    "files_selected": "Vybrané súbory",
    "upload": "Nahrať",
    "uploading": "Nahrávanie",
    "maximum_file_size": "Maximálna povolená veľkosť nahrávania je 10 MB.",
    "download": "Stiahnuť",
    "open_in_new_tab": "Otvoriť v novom okne",
    "delete_file": "Odstrániť súbor",
    "confirm_delete": "Naozaj chcete tento súbor odstrániť?",
    "image_in_use": "Vybraný obrázok sa používa v nasledujúcich aktívnych položkách ponuky:",
    "image_in_use_tip": "Ak chcete tento súbor odstrániť, odstráňte ho zo všetkých aktívnych záznamov.",
    "file_deleted_successfully": "Súbor bol úspešne odstránený",
    "error_deleting_file": "Chyba pri odstraňovaní súboru",
    "confirm_selection": "Potvrdiť výber",
    "file_deletion_forbidden": "Zakázané mazanie súborov"
};

export default gallerySk;
